import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
import { Trip } from '../../../models/trip';
import * as moment from 'moment';

declare const google: any;

@Component({
  selector: 'app-trip-view',
  templateUrl: './trip-view.component.html',
  styleUrls: ['./trip-view.component.css']
})
export class TripViewComponent implements OnInit {


  trip: Trip;
  dateTimeInterval: any;
  clients: any[];
  schools: any[];
  buses: any[];
  client: any;
  map: any;
  address: string;
  marker: any;
  markerBounds: any;
  schoolPosition = { lat: 33.97008408418035, lng: -6.849778033398479 };
  tripPosition = { lat: 33.906203, lng: -6.9299658 };
  geocoder: any;

  dateTimeFilterWE = (d: moment.Moment): boolean => {
    const day = d.day();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
  }
  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private roleService: NgxRolesService
  ) { }

  ngOnInit() {
    this.trip = new Trip();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.client = this.authService.getUser().School.Client;
    } else {
      this.client = this.authService.getUser();
    }

    this.route.params.subscribe(params => {
      this.http.get(
        '/api/trip/' + params['id']
      ).subscribe((trip: Trip) => {
        this.trip = trip;
        this.dateTimeInterval = [
          new Date(this.trip.departureDate),
          new Date(this.trip.returnDate)
        ];
        this.tripPosition = { lat: +this.trip.destLat, lng: +this.trip.destLng };
        this.initSchoolSelect();
      });
    });
    this.map = new google.maps.Map(document.getElementById('trip-map'), {
      zoom: 10,
      center: this.tripPosition,
    });
  }

  initSchoolSelect() {

    const params = new HttpParams({
      fromObject: {
        clientId: this.client.id
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      this.initBusSelect();
    });
  }

  initBusSelect() {
    const params = new HttpParams({
      fromObject: {
        clientId: this.client.id,
        schoolId: '0'
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      for (let i = 0; i < this.schools.length; i++) {
        if (this.schools[i].id == this.trip.schoolId) {
          this.schoolPosition = { lat: Number(this.schools[i].lat), lng: Number(this.schools[i].lng) };
        }
      }
      this.initMap();
    });
  }

  initMap() {
    this.map = new google.maps.Map(document.getElementById('trip-map'), {
      zoom: 10,
      center: this.tripPosition,
    });
    this.markerBounds = new google.maps.LatLngBounds();

    this.marker = new google.maps.Marker({
      position: this.tripPosition,
      map: this.map,
      anchorPoint: new google.maps.Point(0, -29),
      draggable: true
    });
    const markerSchool = new google.maps.Marker({
      position: this.schoolPosition,
      map: this.map,
      icon: 'assets/images/markers/school.png'
    });
    this.markerBounds.extend(this.tripPosition);
    this.markerBounds.extend(this.schoolPosition);

    this.mapAutoComplete(this.map);

    this.geocoder = new google.maps.Geocoder();
    this.getAdressName(this.marker, this.geocoder);
    google.maps.event.addListener(this.marker, 'dragend', () => {
      this.getAdressName(this.marker, this.geocoder);
    });

  }

  getAdressName(marker, geocoder) {
    this.geocoder.geocode({
      'latLng': marker.getPosition()
    }, (results, status) => {
      if (status == google.maps.GeocoderStatus.OK) {

        if (results[0]) {
          const address = this.addressByFormat(results, 'postal_code');
          const locationName = address.formatted_address;

          this.address = locationName;
          this.trip.destLat = marker.getPosition().lat();
          this.trip.destLng = marker.getPosition().lng();
          this.markerBounds.extend({ lat: marker.getPosition().lat(), lng: marker.getPosition().lng() });
          this.map.fitBounds(this.markerBounds);
        }
      }
    });

  }

  addressByFormat(addresses, format) {
    let result = null;
    for (let i = addresses.length - 1; i >= 0; i--) {
      if (addresses[i].types.indexOf(format) >= 0) {
        result = addresses[i];
      }
    }
    return result || addresses[0];
  }

  mapAutoComplete(map) {
    const input = document.getElementById('address');
    const autocomplete = new google.maps.places.Autocomplete(input);
    autocomplete.bindTo('bounds', map);

    // Set the data fields to return when the user selects a place.
    autocomplete.setFields(
      ['address_components', 'geometry', 'icon', 'name']);

    autocomplete.addListener('place_changed', () => {

      this.marker.setVisible(false);
      const place = autocomplete.getPlace();
      if (!place.geometry) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        window.alert('No details available for input: "' + place.name + '"');
        return;
      }

      // If the place has a geometry, then present it on a map.
      this.markerBounds.extend(place.geometry.location);
      map.fitBounds(this.markerBounds);

      this.marker.setPosition(place.geometry.location);
      this.marker.setVisible(true);

      this.getAdressName(this.marker, this.geocoder);
    });
  }


  changePosition() {
    this.marker.setPosition({ lat: this.trip.destLat, lng: this.trip.destLng });
    this.getAdressName(this.marker, this.geocoder);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/trip/trip-view/trip-view.component.ts